function isVisibleTreeItem(item) {
  let current = item;
  while (current && current !== document.body) {
    const style = getComputedStyle(current);
    if (style.display === 'none' || style.visibility === 'hidden') {
      return false;
    }
    current = current.parentElement;
  }
  return true;
}

export function getVisibleTreeItems(rootEl) {
  if (!rootEl) {
    return [];
  }
  return [...rootEl.querySelectorAll('[role="treeitem"]')]
    .filter(isVisibleTreeItem);
}

export function setRovingTabIndex(items, activeItem) {
  if (!activeItem) {
    return;
  }
  items.forEach(item => item.setAttribute('tabindex', item === activeItem ? '0' : '-1'));
}

export function focusTreeItem(rootEl, item) {
  if (!item) {
    return;
  }
  setRovingTabIndex(getVisibleTreeItems(rootEl), item);
  item.focus();
}

function findParentFolderButton(current) {
  const folderContainer = current.closest('.folders-container');
  const parentTreeNode = folderContainer?.closest('.tree-node');
  return parentTreeNode?.querySelector(':scope > .cwd .folder-name') || null;
}

function findPreviousFolder(items, currentIndex) {
  for (let index = currentIndex - 1; index >= 0; index -= 1) {
    if (items[index].classList.contains('folder-name')) {
      return items[index];
    }
  }
  return null;
}

export function initTreeTabIndex(rootEl) {
  const items = getVisibleTreeItems(rootEl);
  if (!items.length) {
    return false;
  }
  const selectedItem = items.find(item => item.getAttribute('aria-selected') === 'true');
  setRovingTabIndex(items, selectedItem || items[0]);
  return true;
}

export function handleTreeKeydown(rootEl, event) {
  const items = getVisibleTreeItems(rootEl);
  const currentIndex = items.indexOf(document.activeElement);
  if (currentIndex === -1) {
    return;
  }

  const current = items[currentIndex];
  const isFolder = current.classList.contains('folder-name');
  const expanded = current.getAttribute('aria-expanded') === 'true';

  switch (event.key) {
    case 'ArrowDown':
      event.preventDefault();
      focusTreeItem(rootEl, items[currentIndex + 1]);
      break;
    case 'ArrowUp':
      event.preventDefault();
      focusTreeItem(rootEl, items[currentIndex - 1]);
      break;
    case 'ArrowRight':
      if (isFolder && !expanded) {
        event.preventDefault();
        current.click();
      } else if (isFolder && expanded && items[currentIndex + 1]) {
        event.preventDefault();
        focusTreeItem(rootEl, items[currentIndex + 1]);
      }
      break;
    case 'ArrowLeft':
      if (isFolder && expanded) {
        event.preventDefault();
        current.click();
      } else {
        event.preventDefault();
        focusTreeItem(rootEl, findParentFolderButton(current) || findPreviousFolder(items, currentIndex));
      }
      break;
    case 'Home':
      event.preventDefault();
      focusTreeItem(rootEl, items[0]);
      break;
    case 'End':
      event.preventDefault();
      focusTreeItem(rootEl, items[items.length - 1]);
      break;
    default:
      break;
  }
}
